module.exports = __webpack_public_path__ + "img/Monte_Kope_DJI_0239.0639ae39.jpg";